import { request, proto } from '../main'

/**
 * 后台管理员获取用户配置列表
 *
 * @param {PBGetUserConfigListReq} query
 * @return {PBUserConfigList}
 */
export function getUserConfigList(query) {
  const pbReq = proto.create('fw.PBGetUserConfigListReq', query)
  return request('fw.userConfigListBg', pbReq, 'fw.PBUserConfigProductList')
}

/**
 * 对IP管理待处理任务进行处理
 *
 * @param {PBHandlePendingConfigReq} query
 */
export function handleUserConfigPending (query) {
  const pbReq = proto.create('fw.PBHandlePendingConfigReq', query)
  return request('fw.userConfigHandlePendingBg', pbReq)
}

/**
 * 根据用户id获取用户动画素材配置列表
 *
 * @param {Number} userId
 */
export function animationConfigGetByUserId (userId) {
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(userId)
  })
  return request('fw.animationConfigGetByUserId', pbReq, 'fw.PBAnimUserList')
}



// WEBPACK FOOTER //
// ./src/api/userConfig.js